module.exports = __webpack_public_path__ + "static/img/new-home-dui.47e7fcb7.png";